import React from "react";
//Containers
import RouteSelector from "../containers/RouteSelector";
import DynamicSelector from "../containers/DynamicSelector";
import NotFound from "../templates/NotFound";
import Map from "../containers/Map";

import Routes from "./Routes";

import { Switch, Route } from "react-router-dom";

import { views } from "./../services/constants";

//This implements the dynamic routes
// <Route exact path="/:lang/**/" component={(props) => <DynamicSelector {...props} />} />

const Router = () => (
  <Switch>
    <Route
      exact
      path="/:lang?"
      component={() => (
        <RouteSelector
          activeView={views.index}
          file="home"
          document="home"
          sideNav={false}
        />
      )}
    />

    {Routes.routes.map(({ component: Component, path, ...route }, index) => {
      return (
        <Route
          key={index}
          path={[`/:lang${path[0]}`, `/:lang${path[1]}`]}
          component={() => <Component {...route.props} />}
        />
      );
    })}

    <Route
      exact
      path="/:lang/map"
      component={() => <Map activeView="index" sideNav={false} />}
    />

    <Route
      exact
      path="/:lang/404"
      component={() => <NotFound activeView="index" sideNav={false} />}
    />

    <Route
      exact
      path="/:lang/**/"
      component={props => (
        <DynamicSelector activeView={views.index} {...props} />
      )}
    />

    <Route
      render={({ staticContext }) => {
        if (staticContext) staticContext.status = 404;
        return <NotFound activeView="index" sideNav={false} />;
      }}
    />
  </Switch>
);

export default Router;
